module.exports = "//static.hsappstatic.net/growth-onboarding-confetti/static-1.282/images/sprocket.svg"